import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { useState } from "react";
import {
  Calendar,
  Phone,
  Mail,
  MessageCircle,
  Facebook,
  Linkedin,
  Instagram,
  FileText,
  FileCheck,
  Home,
  ExternalLink,
  MapPin,
  Clock,
  Shield,
  Calculator,
  Users,
  QrCode,
  X,
  Download,
  Share2,
  RefreshCw,
  Moon,
  TrendingUp,
  User
} from "lucide-react";

// Broker Data
const brokers = {
  zahirul: {
    name: "Zahirul Bhuyain",
    title: "Senior Mortgage & Protection Adviser",
    subtitle: "Residential & Commercial Mortgages | Buy-to-Let | Protection",
    image: "https://customer-assets.emergentagent.com/job_253ab87a-e10d-46f5-9b4d-bd4ec5274312/artifacts/6o53gkj1_zahirul%202bhuyain.jpg.jpeg",
    phone: "07550199399",
    email: "zahir@thamesresi.com",
    location: "Unit 4.1, Town Quay Wharf, Abbey Road, Barking, IG11 7BZ",
    bio: "Helping families and investors achieve their property dreams with expert mortgage advice. FCA regulated, dedicated to finding the best deals for you.",
    socialLinks: [
      { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61587755070013", icon: Facebook, color: "bg-blue-600" },
      { name: "LinkedIn", url: "https://www.linkedin.com/in/zahirul-alam-bhuyain-15253a27/", icon: Linkedin, color: "bg-blue-700" },
      { name: "Instagram", url: "https://instagram.com/thamesmortgage", icon: Instagram, color: "bg-pink-600" },
    ],
    links: [
      { 
        name: "Book a Consultation", 
        description: "Schedule a call at your convenience",
        url: "/book-appointment", 
        icon: Calendar, 
        color: "from-blue-600 to-blue-700",
        featured: true
      },
      { 
        name: "Call Me Now", 
        description: "Direct line: 07550199399",
        url: "tel:07550199399", 
        icon: Phone, 
        color: "from-green-600 to-green-700",
        featured: true
      },
      { 
        name: "WhatsApp Chat", 
        description: "Quick questions? Message me",
        url: "https://wa.me/447550199399", 
        icon: MessageCircle, 
        color: "from-emerald-600 to-emerald-700",
        external: true
      },
      { 
        name: "Check My File", 
        description: "Get your free credit report",
        url: "https://www.checkmyfile.partners/253PGQ8/2CTPL/", 
        icon: FileCheck, 
        color: "from-cyan-600 to-cyan-700",
        external: true
      },
      { 
        name: "Best Rate Table", 
        description: "Compare today's best rates",
        url: "/best-rates", 
        icon: TrendingUp, 
        color: "from-purple-600 to-purple-700"
      },
      { 
        name: "First-Time Buyer Guide", 
        description: "Everything you need to know",
        url: "/first-time-buyer-guide", 
        icon: FileText, 
        color: "from-amber-600 to-amber-700"
      },
      { 
        name: "Re-mortgage Rates Review", 
        description: "Is it time to switch?",
        url: "/remortgage-guide", 
        icon: RefreshCw, 
        color: "from-green-600 to-teal-700"
      },
      { 
        name: "Life & Protection Cover", 
        description: "Protect your family's future",
        url: "/protection-guide", 
        icon: Shield, 
        color: "from-rose-600 to-red-700"
      },
      { 
        name: "Islamic Mortgage & Protection", 
        description: "Sharia-compliant finance",
        url: "/islamic-finance-guide", 
        icon: Moon, 
        color: "from-emerald-600 to-teal-700"
      },
      { 
        name: "Documents Required", 
        description: "Submit your details & checklist",
        url: "/documents-required", 
        icon: FileCheck, 
        color: "from-blue-600 to-indigo-700"
      },
      { 
        name: "Visit Our Website", 
        description: "Thames Mortgage & Protection",
        url: "/", 
        icon: Home, 
        color: "from-slate-600 to-slate-700"
      },
    ]
  },
  mihir: {
    name: "Md Muhibuzzaman",
    title: "Mortgage & Protection Adviser",
    subtitle: "Residential & Commercial Mortgages | Buy-to-Let | Protection",
    image: "https://customer-assets.emergentagent.com/job_253ab87a-e10d-46f5-9b4d-bd4ec5274312/artifacts/0394egmt_Md%20Muhibuzzaman.png",
    phone: "07872614330",
    email: "mihir@thamesresi.com",
    location: "Unit 4.1, Town Quay Wharf, Abbey Road, Barking, IG11 7BZ",
    bio: "Dedicated to finding the best mortgage solutions for families and investors. FCA regulated, with a passion for making home ownership accessible to everyone.",
    socialLinks: [
      { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61587755070013", icon: Facebook, color: "bg-blue-600" },
      { name: "LinkedIn", url: "https://www.linkedin.com/in/mihir-md-muhibuzzaman-cemap-a1a25138/", icon: Linkedin, color: "bg-blue-700" },
      { name: "Instagram", url: "https://instagram.com/thamesmortgage", icon: Instagram, color: "bg-pink-600" },
    ],
    links: [
      { 
        name: "Book a Consultation", 
        description: "Schedule a call at your convenience",
        url: "/book-appointment", 
        icon: Calendar, 
        color: "from-blue-600 to-blue-700",
        featured: true
      },
      { 
        name: "Call Me Now", 
        description: "Direct line: 07872614330",
        url: "tel:+447872614330", 
        icon: Phone, 
        color: "from-green-600 to-green-700",
        featured: true
      },
      { 
        name: "WhatsApp Chat", 
        description: "Quick questions? Message me",
        url: "https://wa.me/447872614330", 
        icon: MessageCircle, 
        color: "from-emerald-600 to-emerald-700",
        external: true
      },
      { 
        name: "Check My File", 
        description: "Get your free credit report",
        url: "https://www.checkmyfile.partners/253PGQ8/2CTPL/", 
        icon: FileCheck, 
        color: "from-cyan-600 to-cyan-700",
        external: true
      },
      { 
        name: "Best Rate Table", 
        description: "Compare today's best rates",
        url: "/best-rates", 
        icon: TrendingUp, 
        color: "from-purple-600 to-purple-700"
      },
      { 
        name: "First-Time Buyer Guide", 
        description: "Everything you need to know",
        url: "/first-time-buyer-guide", 
        icon: FileText, 
        color: "from-amber-600 to-amber-700"
      },
      { 
        name: "Re-mortgage Rates Review", 
        description: "Is it time to switch?",
        url: "/remortgage-guide", 
        icon: RefreshCw, 
        color: "from-green-600 to-teal-700"
      },
      { 
        name: "Life & Protection Cover", 
        description: "Protect your family's future",
        url: "/protection-guide", 
        icon: Shield, 
        color: "from-rose-600 to-red-700"
      },
      { 
        name: "Islamic Mortgage & Protection", 
        description: "Sharia-compliant finance",
        url: "/islamic-finance-guide", 
        icon: Moon, 
        color: "from-emerald-600 to-teal-700"
      },
      { 
        name: "Documents Required", 
        description: "Submit your details & checklist",
        url: "/documents-required", 
        icon: FileCheck, 
        color: "from-blue-600 to-indigo-700"
      },
      { 
        name: "Visit Our Website", 
        description: "Thames Mortgage & Protection",
        url: "/", 
        icon: Home, 
        color: "from-slate-600 to-slate-700"
      },
    ]
  },
  gill: {
    name: "Gill",
    title: "Mortgage & Protection Adviser",
    subtitle: "Residential Mortgages | Buy-to-Let | Remortgage | Protection",
    image: null,
    phone: "07533662357",
    email: "gill@thamesresi.com",
    location: "Unit 4, Town Quay Wharf, Abbey Road, Barking, IG11 7BZ",
    bio: "Committed to providing tailored mortgage advice with a personal touch. Helping clients navigate the mortgage process with confidence.",
    socialLinks: [
      { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61587755070013", icon: Facebook, color: "bg-blue-600" },
      { name: "Instagram", url: "https://instagram.com/thamesmortgage", icon: Instagram, color: "bg-pink-600" },
    ],
    links: [
      { 
        name: "Book a Consultation", 
        description: "Schedule a call at your convenience",
        url: "/book-appointment", 
        icon: Calendar, 
        color: "from-blue-600 to-blue-700",
        featured: true
      },
      { 
        name: "Call Me Now", 
        description: "Direct line: 07533662357",
        url: "tel:+447533662357", 
        icon: Phone, 
        color: "from-green-600 to-green-700",
        featured: true
      },
      { 
        name: "WhatsApp Chat", 
        description: "Quick questions? Message me",
        url: "https://wa.me/447533662357", 
        icon: MessageCircle, 
        color: "from-emerald-600 to-emerald-700",
        external: true
      },
      { 
        name: "Check My File", 
        description: "Get your free credit report",
        url: "https://www.checkmyfile.partners/253PGQ8/2CTPL/", 
        icon: FileCheck, 
        color: "from-cyan-600 to-cyan-700",
        external: true
      },
      { 
        name: "Best Rate Table", 
        description: "Compare today's best rates",
        url: "/best-rates", 
        icon: TrendingUp, 
        color: "from-purple-600 to-purple-700"
      },
      { 
        name: "First-Time Buyer Guide", 
        description: "Everything you need to know",
        url: "/first-time-buyer-guide", 
        icon: FileText, 
        color: "from-amber-600 to-amber-700"
      },
      { 
        name: "Re-mortgage Rates Review", 
        description: "Is it time to switch?",
        url: "/remortgage-guide", 
        icon: RefreshCw, 
        color: "from-green-600 to-teal-700"
      },
      { 
        name: "Life & Protection Cover", 
        description: "Protect your family's future",
        url: "/protection-guide", 
        icon: Shield, 
        color: "from-rose-600 to-red-700"
      },
      { 
        name: "Documents Required", 
        description: "Submit your details & checklist",
        url: "/documents-required", 
        icon: FileCheck, 
        color: "from-blue-600 to-indigo-700"
      },
      { 
        name: "Visit Our Website", 
        description: "Thames Mortgage & Protection",
        url: "/", 
        icon: Home, 
        color: "from-slate-600 to-slate-700"
      },
    ]
  },
  broker2: {
    name: "Sarah Mitchell",
    title: "Mortgage & Protection Specialist",
    subtitle: "First-Time Buyers | Remortgages | Buy-to-Let Expert",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face",
    phone: "02080506062",
    email: "sarah@thamesresi.com",
    location: "Unit 4.1, Town Quay Wharf, Abbey Road, Barking, IG11 7BZ",
    bio: "Passionate about helping first-time buyers get on the property ladder. With years of experience, I make the mortgage process simple and stress-free.",
    socialLinks: [
      { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61587755070013", icon: Facebook, color: "bg-blue-600" },
      { name: "LinkedIn", url: "https://linkedin.com/in/sarahmitchell", icon: Linkedin, color: "bg-blue-700" },
      { name: "Instagram", url: "https://instagram.com/thamesmortgage", icon: Instagram, color: "bg-pink-600" },
    ],
    links: [
      { 
        name: "Book a Consultation", 
        description: "Let's discuss your mortgage needs",
        url: "/book-appointment", 
        icon: Calendar, 
        color: "from-blue-600 to-blue-700",
        featured: true
      },
      { 
        name: "Call Me Direct", 
        description: "Phone: 02080506062",
        url: "tel:02080506062", 
        icon: Phone, 
        color: "from-green-600 to-green-700",
        featured: true
      },
      { 
        name: "WhatsApp Me", 
        description: "Fast response guaranteed",
        url: "https://wa.me/442080506062", 
        icon: MessageCircle, 
        color: "from-emerald-600 to-emerald-700",
        external: true
      },
      { 
        name: "AI Mortgage Advisor", 
        description: "Get instant answers 24/7",
        url: "/", 
        icon: MessageCircle, 
        color: "from-purple-600 to-purple-700"
      },
      { 
        name: "Remortgage Guide", 
        description: "Is it time to switch?",
        url: "#", 
        icon: FileText, 
        color: "from-amber-600 to-amber-700"
      },
      { 
        name: "Protection Planning", 
        description: "Life insurance & income protection",
        url: "#", 
        icon: Shield, 
        color: "from-rose-600 to-rose-700"
      },
      { 
        name: "Email Me", 
        description: "sarah@thamesresi.com",
        url: "mailto:sarah@thamesresi.com", 
        icon: Mail, 
        color: "from-cyan-600 to-cyan-700"
      },
      { 
        name: "Our Main Website", 
        description: "Thames Mortgage & Protection",
        url: "/", 
        icon: Home, 
        color: "from-slate-600 to-slate-700"
      },
    ]
  }
};

export default function LinkInBio({ brokerId = "zahirul" }) {
  const broker = brokers[brokerId] || brokers.zahirul;
  const location = useLocation();
  const [showQRModal, setShowQRModal] = useState(false);
  
  // Generate the full URL for the QR code
  const pageUrl = typeof window !== 'undefined' 
    ? `${window.location.origin}${location.pathname}`
    : `/bio/${brokerId}`;

  const downloadQRCode = () => {
    const svg = document.getElementById('qr-code-svg');
    if (svg) {
      const svgData = new XMLSerializer().serializeToString(svg);
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.onload = () => {
        canvas.width = 300;
        canvas.height = 300;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, 300, 300);
        const pngFile = canvas.toDataURL('image/png');
        const downloadLink = document.createElement('a');
        downloadLink.download = `${broker.name.replace(/\s+/g, '_')}_QR.png`;
        downloadLink.href = pngFile;
        downloadLink.click();
      };
      img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
    }
  };

  const shareProfile = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${broker.name} - Thames Mortgage & Protection`,
          text: `Get expert mortgage advice from ${broker.name}`,
          url: pageUrl
        });
      } catch (err) {
        console.log('Share cancelled');
      }
    } else {
      navigator.clipboard.writeText(pageUrl);
      alert('Link copied to clipboard!');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#020617] via-[#0f172a] to-[#020617] text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-lg mx-auto px-4 py-8">
        {/* Profile Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          {/* Profile Image */}
          <div className="relative inline-block mb-4">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full blur-lg opacity-50"></div>
            {broker.image ? (
              <img
                src={broker.image}
                alt={broker.name}
                className="relative w-32 h-32 rounded-full object-cover border-4 border-white/20 shadow-2xl"
              />
            ) : (
              <div className="relative w-32 h-32 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 border-4 border-white/20 shadow-2xl flex items-center justify-center">
                <User className="w-16 h-16 text-white/80" />
              </div>
            )}
            <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-green-500 rounded-full border-4 border-[#0f172a] flex items-center justify-center">
              <span className="text-xs">✓</span>
            </div>
          </div>

          {/* Name & Title */}
          <h1 className="text-2xl font-bold mb-1">{broker.name}</h1>
          <p className="text-blue-400 font-medium mb-2">{broker.title}</p>
          <p className="text-slate-400 text-sm mb-4">{broker.subtitle}</p>
          
          {/* Bio */}
          <p className="text-slate-300 text-sm leading-relaxed max-w-sm mx-auto mb-4">
            {broker.bio}
          </p>

          {/* Location & Hours */}
          <div className="flex items-center justify-center gap-4 text-xs text-slate-400 mb-4">
            <span className="flex items-center gap-1">
              <MapPin className="w-3 h-3" /> London, UK
            </span>
            <span className="flex items-center gap-1">
              <Clock className="w-3 h-3" /> Mon-Fri 9am-6pm
            </span>
          </div>

          {/* Social Links */}
          <div className="flex justify-center gap-3 mb-4">
            {broker.socialLinks.map((social, index) => (
              <motion.a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                className={`w-10 h-10 ${social.color} rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-lg`}
              >
                <social.icon className="w-5 h-5" />
              </motion.a>
            ))}
          </div>

          {/* QR Code & Share Buttons */}
          <div className="flex justify-center gap-3 mb-6">
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.3 }}
              onClick={() => setShowQRModal(true)}
              className="flex items-center gap-2 px-4 py-2 bg-slate-800/80 hover:bg-slate-700/80 border border-slate-600/50 rounded-full text-sm text-slate-300 hover:text-white transition-all"
              data-testid="qr-code-btn"
            >
              <QrCode className="w-4 h-4" />
              QR Code
            </motion.button>
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.4 }}
              onClick={shareProfile}
              className="flex items-center gap-2 px-4 py-2 bg-slate-800/80 hover:bg-slate-700/80 border border-slate-600/50 rounded-full text-sm text-slate-300 hover:text-white transition-all"
              data-testid="share-profile-btn"
            >
              <Share2 className="w-4 h-4" />
              Share
            </motion.button>
          </div>
        </motion.div>

        {/* Links */}
        <div className="space-y-3">
          {broker.links.map((link, index) => (
            <motion.div
              key={link.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 + index * 0.05 }}
            >
              {link.external ? (
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`block w-full p-4 rounded-2xl bg-gradient-to-r ${link.color} hover:scale-[1.02] transition-all shadow-lg group`}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                      <link.icon className="w-6 h-6" />
                    </div>
                    <div className="flex-1 text-left">
                      <p className="font-semibold">{link.name}</p>
                      <p className="text-sm text-white/70">{link.description}</p>
                    </div>
                    <ExternalLink className="w-5 h-5 opacity-50 group-hover:opacity-100 transition" />
                  </div>
                </a>
              ) : link.url.startsWith("tel:") || link.url.startsWith("mailto:") ? (
                <a
                  href={link.url}
                  className={`block w-full p-4 rounded-2xl bg-gradient-to-r ${link.color} hover:scale-[1.02] transition-all shadow-lg group`}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                      <link.icon className="w-6 h-6" />
                    </div>
                    <div className="flex-1 text-left">
                      <p className="font-semibold">{link.name}</p>
                      <p className="text-sm text-white/70">{link.description}</p>
                    </div>
                  </div>
                </a>
              ) : (
                <Link
                  to={link.url}
                  className={`block w-full p-4 rounded-2xl bg-gradient-to-r ${link.color} hover:scale-[1.02] transition-all shadow-lg group`}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                      <link.icon className="w-6 h-6" />
                    </div>
                    <div className="flex-1 text-left">
                      <p className="font-semibold">{link.name}</p>
                      <p className="text-sm text-white/70">{link.description}</p>
                    </div>
                  </div>
                </Link>
              )}
            </motion.div>
          ))}
        </div>

        {/* Footer */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-10 text-center"
        >
          <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition text-sm">
            <div className="w-6 h-6 bg-gradient-to-br from-blue-500 to-amber-500 rounded-lg flex items-center justify-center">
              <Home className="w-3 h-3 text-white" />
            </div>
            Thames Mortgage & Protection
          </Link>
          <p className="text-xs text-slate-500 mt-3">
            FCA Regulated • FRN 1045227
          </p>
          <p className="text-xs text-amber-500 mt-2 font-medium">
            Your home may be repossessed if you do not keep up repayments on your mortgage or loans secured on it.
          </p>
        </motion.div>
      </div>

      {/* QR Code Modal */}
      {showQRModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setShowQRModal(false)}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="bg-[#0f172a] border border-slate-700 rounded-2xl p-6 max-w-sm w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-white">Scan to Connect</h3>
              <button
                onClick={() => setShowQRModal(false)}
                className="p-1 hover:bg-slate-800 rounded-lg transition"
              >
                <X className="w-5 h-5 text-slate-400" />
              </button>
            </div>
            
            <div className="bg-white p-4 rounded-xl mb-4 flex justify-center">
              <QRCodeSVG
                id="qr-code-svg"
                value={pageUrl}
                size={200}
                level="H"
                includeMargin={true}
                bgColor="#ffffff"
                fgColor="#0f172a"
              />
            </div>
            
            <div className="text-center mb-4">
              <p className="text-white font-medium">{broker.name}</p>
              <p className="text-sm text-slate-400">{broker.title}</p>
            </div>

            <div className="flex gap-2">
              <button
                onClick={downloadQRCode}
                className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition"
                data-testid="download-qr-btn"
              >
                <Download className="w-4 h-4" />
                Download
              </button>
              <button
                onClick={shareProfile}
                className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition"
                data-testid="share-from-modal-btn"
              >
                <Share2 className="w-4 h-4" />
                Share Link
              </button>
            </div>
            
            <p className="text-xs text-slate-500 text-center mt-4">
              Scan this QR code to view my profile
            </p>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
}

// Export broker IDs for routing
export const brokerIds = Object.keys(brokers);
